import { render } from "./ConsultaCobertura.vue?vue&type=template&id=49a4e016&scoped=true"
import script from "./ConsultaCobertura.vue?vue&type=script&lang=js"
export * from "./ConsultaCobertura.vue?vue&type=script&lang=js"

import "./ConsultaCobertura.vue?vue&type=style&index=0&id=49a4e016&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a4e016"]])

export default __exports__